import { Timestamp } from 'firebase/firestore'
import { Dispatch, SetStateAction } from 'react'
import { Cause } from './CauseInterface'
import { Skill } from './SkillInterface'

export interface User {
  bio: string | null
  birthday: Timestamp
  causes: string[]
  city?: string
  companyEmails?: string[]
  confirmPassword?: string
  createdAt: Timestamp
  email?: string
  firstName: string
  followers: number
  following: number
  gender?: string
  id?: string
  invitedOrgs?: string[]
  lastName: string
  lastUpdate?: Timestamp
  lastUpdated?: Timestamp
  lat?: number
  lng?: number
  lowercaseName: string
  password?: string
  phone?: string
  profilePic?: string
  savePaymentInfo?: boolean
  showCausesOnProfile?: boolean
  showChampionLinkOnProfile?: boolean
  showLocationOnProfile?: boolean
  showSkillsOnProfile?: boolean
  skills: string[]
  state?: string
  stripeCustomerId?: string
  supportedNonprofit?: { id: string; amountRaised: number }[]
  tokens: string[]
  uid?: string
  username: string
  zipCode: string
}

export interface CurrentAuth {
  uid: string
  email?: string
}

export interface OpportunitiesVolunteer extends Partial<User> {
  level?: string
  status?: string
}

// Context Props
export interface UserContextProps {
  selectedUser: User | null
  setSelectedUser: Dispatch<SetStateAction<User | null>>
  causes: Cause[] | null
  skills: Skill[] | null
  // Future fields (not currently used in context but may be needed)
  nextPage?: () => void
  users?: User[]
  setUsers?: Dispatch<SetStateAction<User[]>>
  setGetUsers?: Dispatch<SetStateAction<boolean>>
  page?: number
  setPage?: Dispatch<SetStateAction<number>>
  sortedBy?: { sortBy?: string; sortOrder?: 'asc' | 'desc' }
  handleSort?: (sortBy: string) => void
}

export const UserContextDefaultValues: UserContextProps = {
  selectedUser: null,
  setSelectedUser: () => {},
  causes: null,
  skills: null,
}
